import service from './index'

const resource = service.resource('trainers/by-user{/id}')
const resourceAll = service.resource('trainers')
const resourceId = service.resource('trainers{/id}')

export default {
  // Read
  get (id) {
    return resource.get({id: id})
  },

  getAll () {
    return resourceAll.get()
  },

  getTrainer(id){
    return resourceId.get({id: id})
  }
}




// WEBPACK FOOTER //
// ./src/services/trainer.js